<template>
  <div id="email">
    <!-- <h3>邮件</h3> -->
    <el-card class="index">
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
        style="min-height: calc(100vh - 220px)"
      >
        <el-tab-pane label="所有通知" name="first">
          <div class="main">
            <div class="contain" v-for="item in notice" :key="item.id">
              <div class="time">
                {{ handleTime(JsonFTime(item.noticeTime), 'yyyy-MM-dd HH:mm') }}
                <!-- <span v-if="item.status == 1 && item.con.includes('需要审批')" style="color: #f85531">未审核</span> -->
                <span v-if="item.status == 1" style="color: #f85531">未读</span>
              </div>
              <div class="title">
                <span v-if="item.msgType == '冲突检索'">
                  {{ item.con }}
                </span>
                <span v-if="item.msgType == 'case_entry'">
                  案件<span>{{ item.bcase }}</span>
                  <span v-if="item.con.includes('需要审批')"> 提醒您审批</span>
                  <span v-if="item.con.includes('通过')">通过审批</span>
                  <span v-if="item.con.includes('驳回')">被驳回</span>
                </span>

                <span v-if="item.msgType == 'tender_entry'">
                  <span v-if="item.con.includes('需要审批')">
                    <span>{{ item.tender }}</span>
                    的投标申请，提醒您审批<span v-if="item.tenderStatus == -1"
                      >(已撤销申请)</span
                    ></span
                  >
                  <span v-if="item.con.includes('通过')"
                    >您的投标申请通过审批</span
                  >
                  <span v-if="item.con.includes('驳回')"
                    >您的投标申请被驳回</span
                  >
                </span>
                <span v-if="item.msgType.includes('_seal')">
                  <span v-if="item.con.includes('需要审批')">
                    <span>{{ item.seal }}</span>
                    的用章申请，提醒您审批<span v-if="item.sealStatus == -1"
                      >(已撤销申请)</span
                    ></span
                  >
                  <span v-if="item.con.includes('通过')"
                    >您的用章申请通过审批</span
                  >
                  <span v-if="item.con.includes('驳回')"
                    >您的用章申请被驳回</span
                  >
                </span>

                <span v-if="item.msgType == 'adviser_entry'">
                  <span v-if="item.con.includes('需要审批')">
                    <span>{{ item.advisers }}</span>
                    的顾问申请，提醒您审批</span
                  >
                  <span v-if="item.con.includes('通过')"
                    >您的顾问申请通过审批</span
                  >
                  <span v-if="item.con.includes('驳回')"
                    >您的顾问申请被驳回</span
                  >
                </span>

                <span v-if="item.msgType == 'reminder_entry'">
                  <span>{{ item.reminder }}</span
                  >日程即将开始
                  <!-- <span v-if="item.con.includes('需要审批') ">
                    <span>{{ item.advisers}}</span>
                     的顾问申请，提醒您审批</span>
                  <span v-if="item.con.includes('通过')">您的顾问申请通过审批</span>
                  <span v-if="item.con.includes('驳回')">您的顾问申请被驳回</span> -->
                </span>
                <br />
                <span
                  class="tiaoz"
                  v-if="
                    item.con.includes('需要审批') &&
                    item.status == 1 &&
                    (item.sealStatus == 1 || item.tenderStatus == 1)
                  "
                  @click="update(item, 'approval')"
                  >去审批</span
                >
                <span
                  class="tiaoz"
                  v-if="
                    item.con.includes('需要审批') &&
                    item.status == 1 &&
                    item.sealStatus == null &&
                    item.tenderStatus == null
                  "
                  @click="update(item, 'approval')"
                  >去审批</span
                >
                <span
                  class="tiaoz"
                  v-if="
                    item.con.includes('需要审批') &&
                    item.status == 1 &&
                    (item.sealStatus == -1 || item.tenderStatus == -1)
                  "
                  @click="update(item, 'approval')"
                  >点此已读</span
                >

                <span
                  class="tiaoz"
                  v-if="!item.con.includes('需要审批')"
                  @click="update(item, 'look')"
                  >去查看</span
                >
              </div>
              <div class="xian"></div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="案件审批" name="second">
          <div class="main">
            <div class="contain" v-for="item in notice" :key="item.id">
              <div class="time">
                {{ handleTime(JsonFTime(item.noticeTime), 'yyyy-MM-dd HH:mm') }}
                <!-- <span v-if="item.status == 1 && item.con.includes('需要审批')" style="color: #f85531">未审核</span> -->
                <span v-if="item.status == 1" style="color: #f85531">未读</span>
              </div>
              <div class="title">
                <span v-if="item.msgType == 'case_entry'">
                  案件<span>{{ item.bcase }}</span>
                  <span v-if="item.con.includes('需要审批')"> 提醒您审批</span>
                  <span v-if="item.con.includes('通过')">通过审批</span>
                  <span v-if="item.con.includes('驳回')">被驳回</span>
                </span>
                <br />
                <span
                  class="tiaoz"
                  v-if="item.con.includes('需要审批') && item.status == 1"
                  @click="update(item, 'approval')"
                  >去审批</span
                >
                <span
                  class="tiaoz"
                  v-if="!item.con.includes('需要审批')"
                  @click="update(item, 'look')"
                  >去查看</span
                >
              </div>
              <div class="xian"></div>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="用章审批" name="third">
          <div class="main">
            <div class="contain" v-for="item in notice" :key="item.id">
              <div class="time">
                {{ handleTime(JsonFTime(item.noticeTime), 'yyyy-MM-dd HH:mm') }}
                <!-- <span v-if="item.status == 1 && item.con.includes('需要审批')" style="color: #f85531">未审核</span> -->
                <span v-if="item.status == 1" style="color: #f85531">未读</span>
              </div>
              <div class="title">
                <span v-if="item.msgType.includes('seal')">
                  <span v-if="item.con.includes('需要审批')">
                    <span>{{ item.seal }}</span>
                    申请用章，提醒您审批<span v-if="item.sealStatus == -1"
                      >(已撤销申请)</span
                    ></span
                  >
                  <span v-if="item.con.includes('通过')"
                    >您的用章申请通过审批</span
                  >
                  <span v-if="item.con.includes('驳回')"
                    >您的用章申请被驳回</span
                  > </span
                ><br />
                <span
                  class="tiaoz"
                  v-if="
                    item.con.includes('需要审批') &&
                    item.status == 1 &&
                    item.sealStatus == 1
                  "
                  @click="update(item, 'approval')"
                  >去审批</span
                >
                <span
                  class="tiaoz"
                  v-if="
                    item.con.includes('需要审批') &&
                    item.status == 1 &&
                    item.sealStatus == -1
                  "
                  @click="update(item, 'approval')"
                  >点此已读</span
                >
                <span
                  class="tiaoz"
                  v-if="!item.con.includes('需要审批')"
                  @click="update(item, 'look')"
                  >去查看</span
                >
              </div>
              <div class="xian"></div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="投标审批" name="fourth">
          <div class="main">
            <div class="contain" v-for="item in notice" :key="item.id">
              <div class="time">
                {{ handleTime(JsonFTime(item.noticeTime), 'yyyy-MM-dd HH:mm') }}
                <!-- <span v-if="item.status == 1 && item.con.includes('需要审批')" style="color: #f85531">未审核</span> -->
                <span v-if="item.status == 1" style="color: #f85531">未读</span>
              </div>
              <div class="title">
                <span v-if="item.msgType == 'tender_entry'">
                  <span v-if="item.con.includes('需要审批')">
                    <span>{{ item.tender }}</span>
                    的投标申请，提醒您审批<span v-if="item.tenderStatus == -1"
                      >(已撤销申请)</span
                    ></span
                  >
                  <span v-if="item.con.includes('通过')"
                    >您的投标申请通过审批</span
                  >
                  <span v-if="item.con.includes('驳回')"
                    >您的投标申请被驳回</span
                  >
                </span>
                <br />
                <span
                  class="tiaoz"
                  v-if="
                    item.con.includes('需要审批') &&
                    item.status == 1 &&
                    item.tenderStatus == 1
                  "
                  @click="update(item, 'approval')"
                  >去审批</span
                >
                <span
                  class="tiaoz"
                  v-if="
                    item.con.includes('需要审批') &&
                    item.status == 1 &&
                    item.tenderStatus == -1
                  "
                  @click="update(item, 'approval')"
                  >点此已读</span
                >
                <span
                  class="tiaoz"
                  v-if="!item.con.includes('需要审批')"
                  @click="update(item, 'look')"
                  >去查看</span
                >
              </div>
              <div class="xian"></div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="顾问审批" name="fifth">
          <div class="main">
            <div class="contain" v-for="item in notice" :key="item.id">
              <div class="time">
                {{ handleTime(JsonFTime(item.noticeTime), 'yyyy-MM-dd HH:mm') }}
                <!-- <span v-if="item.status == 1 && item.con.includes('需要审批')" style="color: #f85531">未审核</span> -->
                <span v-if="item.status == 1" style="color: #f85531">未读</span>
              </div>
              <div class="title">
                <span v-if="item.msgType == 'adviser_entry'">
                  <span v-if="item.con.includes('需要审批')">
                    <span>{{ item.advisers }}</span>
                    的顾问申请，提醒您审批</span
                  >
                  <span v-if="item.con.includes('通过')"
                    >您的顾问申请通过审批</span
                  >
                  <span v-if="item.con.includes('驳回')"
                    >您的顾问申请被驳回</span
                  > </span
                ><br />
                <span
                  class="tiaoz"
                  v-if="item.con.includes('需要审批') && item.status == 1"
                  @click="update(item, 'approval')"
                  >去审批</span
                >
                <span
                  class="tiaoz"
                  v-if="!item.con.includes('需要审批')"
                  @click="update(item, 'look')"
                  >去查看</span
                >
              </div>
              <div class="xian"></div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="日程提醒" name="sixth">
          <div class="main">
            <div class="contain" v-for="item in notice" :key="item.id">
              <div class="time">
                {{ handleTime(JsonFTime(item.noticeTime), 'yyyy-MM-dd HH:mm') }}
                <!-- <span v-if="item.status == 1 && item.con.includes('需要审批')" style="color: #f85531">未审核</span> -->
                <span v-if="item.status == 1" style="color: #f85531">未读</span>
              </div>
              <div class="title">
                <span v-if="item.msgType == 'reminder_entry'">
                  <span>{{ item.reminder }}</span
                  >日程即将开始 </span
                ><br />
                <span
                  class="tiaoz"
                  v-if="item.con.includes('需要审批') && item.status == 1"
                  @click="update(item, 'approval')"
                  >去审批</span
                >

                <span
                  class="tiaoz"
                  v-if="!item.con.includes('需要审批')"
                  @click="update(item, 'look')"
                  >去查看</span
                >
              </div>
              <div class="xian"></div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="未读特殊提醒" name="unspecial">
          <div class="main">
            <div class="contain" v-for="item in unspecialnotice" :key="item.id">
              <div class="time">
                {{ handleTime(JsonFTime(item.cdate), 'yyyy-MM-dd HH:mm:ss') }}
                <!-- <span v-if="item.status == 1 && item.con.includes('需要审批')" style="color: #f85531">未审核</span> -->
                <span style="color: #f85531">未读</span>
              </div>
              <div class="title">
                <span>
                  <span>{{ item.con }}</span>
                </span>
                <br />
                <br />

                <span class="tiaoz" @click="lookspecial(item)">通知详情</span>
              </div>
              <div class="xian"></div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="已读特殊提醒" name="special">
          <div class="main">
            <div class="contain" v-for="item in specialnotice" :key="item.id">
              <div class="time">
                {{ handleTime(JsonFTime(item.cdate), 'yyyy-MM-dd HH:mm:ss') }}
                <!-- <span v-if="item.status == 1 && item.con.includes('需要审批')" style="color: #f85531">未审核</span> -->
              </div>
              <div class="title">
                <span>{{ item.con }}</span>
                <br />
                <br />
                <span class="tiaoz" @click="lookspecial(item)"
                  >查看通知详情</span
                >
              </div>
              <div class="xian"></div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-button
        class="readbtn"
        @click="readbtn"
        size="mini"
        v-if="isbtn && pagination == 'old'"
        >全部已读</el-button
      >

      <div class="bank_pagination">
        <el-pagination
          v-if="pagination == 'old'"
          :current-page.sync="PageIndex"
          :page-sizes="PageSizes"
          :page-size="PageSize"
          :pager-count="MaxPage"
          layout="total, sizes, prev, pager, next"
          :total="Total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
        <el-pagination
          v-if="pagination == 'unnew' || pagination == 'new'"
          :current-page.sync="noticePageIndex"
          :page-sizes="noticePageSizes"
          :page-size="noticePageSize"
          :pager-count="noticeMaxPage"
          layout="total, sizes, prev, pager, next"
          :total="noticeTotal"
          @size-change="noticehandleSizeChange"
          @current-change="noticehandleCurrentChange"
        />
      </div>
    </el-card>

    <el-dialog
      title="冲突检索记录"
      :visible.sync="dialogVisible"
      width="50%"
      center
      :show-close="false"
    >
      <el-table
        :data="tableDate"
        style="width: 100%"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
      >
        <el-table-column prop="name" label="搜索账户" width="150">
        </el-table-column>

        <el-table-column prop="con" label="搜索内容" width="180">
        </el-table-column>
        <el-table-column
          prop="count"
          label="搜索次数"
          width="100"
        ></el-table-column>
        <el-table-column prop="times" label="搜索时间" width="280">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="formatTimes(scope.row.times)"
              placement="top"
              popper-class="tooltip-width"
            >
              <div class="truncate-text">
                <span v-for="(item, index) in scope.row.times" :key="index">
                  {{ JsonFTime(item) }}
                  <span v-if="index < scope.row.times.length - 1">，</span>
                </span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="success" plain size="small" @click="Look(scope.row)">查看</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </el-dialog>

    <el-dialog title="详情" :visible.sync="dialog" width="80%">
      <el-form :model="form" label-width="150px" class="demo-form">
        <el-form-item label="发起人">
          <el-input disabled v-model="form.initiator"></el-input>
        </el-form-item>

        <el-form-item label="发起时间">
          <el-date-picker
            v-model="form.cdate"
            type="datetime"
            placeholder="选择日期时间"
            disabled
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="通知内容">
          <el-input
            type="textarea"
            v-model="form.con"
            :autosize="{ minRows: 10 }"
            disabled
          ></el-input>
        </el-form-item>

        <el-form-item>
          <div style="text-align: center">
            <el-button
              v-if="form.status == '未读'"
              type="primary"
              @click="special_update()"
              >已读</el-button
            >
            <el-button type="warning" @click="dialog = false">关闭</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
  
<script>
import {
  Notice,
  NoticeRead,
  NoticeUnread,
  ConflictWarn,
  AllRead
} from '../../api/First'
import { unreadSelect, readSelect, unreadToRead } from '../../api/case'
// import Header from "../../components/Home/Header.vue";
export default {
  // components: {
  //   Header
  // },
  name: 'email',
  data() {
    return {
      dialog: false,
      isbtn: false, //全部已读按钮是否显示
      activeName: 'first',
      notice: [],
      unspecialnotice: [],
      specialnotice: [],
      type: '0',
      PageSizes: [10, 20, 50, 100],
      PageIndex: 1,
      PageSize: 10,
      Total: 0,
      MaxPage: 5,
      dialogVisible: false,
      tableDate: [],
      form: {
        id: null,
        status: null,
        initiator: null,
        cdate: null,
        con: null
      },

      pagination: 'old',

      noticePageSizes: [10, 20, 50, 100],
      noticePageIndex: 1,
      noticePageSize: 10,
      noticeTotal: 0,
      noticeMaxPage: 5
    }
  },

  methods: {
    //时间转换
    handleTime(time, format) {
      if (time == null || time == undefined || time == '') {
        return ''
      }
      var t = new Date(time.toString().replace(/-/g, '/'))
      var tf = function (i) {
        return (i < 10 ? '0' : '') + i
      }
      return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
        switch (a) {
          case 'yyyy':
            return tf(t.getFullYear())
            break
          case 'MM':
            return tf(t.getMonth() + 1)
            break
          case 'mm':
            return tf(t.getMinutes())
            break
          case 'dd':
            return tf(t.getDate())
            break
          case 'HH':
            return tf(t.getHours())
            break
          case 'ss':
            return tf(t.getSeconds())
            break
        }
      })
    },
    formatTimes(times) {
      return times.map((time) => this.JsonFTime(time)).join(', ')
    },
    // 时间格式
    JsonFTime(time) {
      // yyyy-MM-dd HH:MM:SS
      var t = new Date(time).toJSON()
      return new Date(+new Date(t) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    },
    handleSizeChange(val) {
      this.PageSize = val
      this.getnotice()
    },
    handleCurrentChange(val) {
      this.PageIndex = val
      this.getnotice()
    },

    noticehandleSizeChange(val) {
      this.PageSize = val
      this.getspecialnotice()
    },
    noticehandleCurrentChange(val) {
      this.PageIndex = val
      this.getspecialnotice()
    },

    handleClick(tab, event) {
      this.GetUnRead()
      this.notice = []
      this.Total = 0
      if (tab.name == 'first') {
        //所有
        this.type = '0'
        this.pagination = 'old'
        this.getnotice(this.type)
      }
      if (tab.name == 'second') {
        //案件审批
        this.type = '1'
        this.pagination = 'old'
        this.getnotice(this.type)
      }
      if (tab.name == 'third') {
        //用章审批
        this.type = '2'
        this.pagination = 'old'
        this.getnotice(this.type)
      }
      if (tab.name == 'fourth') {
        //投标审批
        this.type = '3'
        this.pagination = 'old'
        this.getnotice(this.type)
      }
      if (tab.name == 'fifth') {
        //顾问审批
        this.pagination = 'old'
        this.type = '4'
        this.getnotice(this.type)
      }
      if (tab.name == 'sixth') {
        //日程提醒
        this.type = '5'
        this.pagination = 'old'
        this.getnotice(this.type)
      }
      if (tab.name == 'unspecial') {
        //未读特殊提醒
        this.pagination = 'unnew'
        this.getspecialnotice('un')
      }
      if (tab.name == 'special') {
        //已读特殊提醒
        this.pagination = 'new'
        this.getspecialnotice('')
      }
    },

    // 获取通知
    getspecialnotice(p) {
      if (p == 'un' || this.pagination == 'unnew') {
        unreadSelect({
          page: this.noticePageIndex,
          rows: this.noticePageSize
        }).then((res) => {
          this.unspecialnotice = res.data.data
          this.noticeTotal = res.data.total
        })
      } else {
        readSelect({
          page: this.noticePageIndex,
          rows: this.noticePageSize
        }).then((res) => {
          this.specialnotice = res.data.data
          this.noticeTotal = res.data.total
        })
      }
    },

    // 通知详情
    lookspecial(row) {
      // console.log(row)
      this.form.id = row.id
      this.form.initiator = row.initiator
      this.form.cdate = row.cdate
      this.form.con = row.con
      this.form.status = row.status

      this.dialog = true
    },

    // 未读->已读
    special_update() {
      unreadToRead({
        guid: this.form.id
      }).then((res) => {
        if (res.data.status == 'success') {
          this.dialog = false
          this.$message.success('已读成功！')
        } else {
          this.dialog = false
          this.$message.success('已读失败！')
        }
      })
      this.getspecialnotice()
    },

    getnotice(type) {
      Notice({
        page: this.PageIndex,
        rows: this.PageSize,
        Type: this.type
      }).then((res) => {
        if (res.data.status == 'success') {
          this.notice = res.data.data
          this.Total = res.data.total

          if (this.$store.state.total >= 1) {
            this.isbtn = true
          } else {
            this.isbtn = false
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
      // this.notice = [{ id: 1, type: "1", title: '银庄置业诉陆敏、陆勤霞开庭提醒', time: '2023-05-20 13:12', isread: true },
      // { id: 2, type: "1", title: '江苏苏州农村商业银行股份有限公司诉陆春林开庭提醒', time: '2023-05-20 13:12', isread: false },
      // { id: 3, type: "3", title: '顾问李玲即将到期', time: '2023-05-20 13:12', isread: false },
      // { id: 4, type: "1", title: '案件股东损害债权人利益责任纠纷（2018）苏0507民初4058号开庭提醒', time: '2023-05-20 13:12', isread: false },
      // { id: 5, type: "2", title: '保全到期提醒', time: '2023-05-20 13:12', isread: false },
      // { id: 6, type: "1", title: '银庄置业诉陆敏、陆勤霞开庭提醒', time: '2023-05-20 13:12', isread: false },
      // { id: 7, type: "1", title: '案件股东损害债权人利益责任纠纷（2018）苏0507民初4058号开庭提醒', time: '2023-05-20 13:12', isread: false },
      // { id: 8, type: "2", title: '保全到期提醒', time: '2023-05-20 13:12', isread: false },
      // { id: 9, type: "3", title: '顾问李玲即将到期', time: '2023-05-20 13:12', isread: false }];
      // console.log(type)
      // if (type != null&&type!='') {
      //   this.notice = this.notice.filter(item => item.type == type);
      // }
    },
    GetConflicDetail(id, time) {
      ConflictWarn({ InfoId: id, Time: time }).then((res) => {
        this.tableDate = res.data.data
        this.dialogVisible = true
      })
    },

    update(item, type) {
      if (item.msgType == '冲突检索') {
        this.GetConflicDetail(item.infoId, item.noticeTime)
      } else if (item.msgType == 'case_entry') {
        //案件
        var caseType = item.casetype.typeId.substring(21, 23)
        if (type == 'approval') {
          //案件审核
          this.$router.push({
            path: '/home/examine/Casedetail',
            query: {
              guid: item.infoId,
              type: item.casetype.typecase
            }
          })
        } else {
          //案件详情页面
          if (caseType == 13) {
            this.$router.push({
              path: 'bankruptdetail',
              name: 'bankruptdetail',
              query: { guid: item.infoId, type: '破产投标', mystatus: 1 }
            })
          } else if (caseType == 12) {
            this.$router.push({
              path: 'bankruptdetail',
              name: 'bankruptdetail',
              query: { guid: item.infoId, type: '破产', mystatus: 1 }
            })
          } else {
            this.$store.commit('setmenustatus', 1)
            this.$router.push({
              path: '/home/case/caseinfo',
              query: {
                guid: item.infoId,
                status: item.casetype.typeId,
                caseType: caseType,
                mystatus: 1
              }
            })
          }
        }
      } else {
        if (item.msgType == 'adviser_entry') {
          this.$router.push({
            path: '/home/counsel/legalCounsel'
          })
        } else if (item.msgType == 'reminder_entry') {
          this.$router.push({
            path: '/home/homePage/firstPage'
          })
        } else if (item.msgType.includes('_seal')) {
          if (item.sealStatus == -1) {
            //已撤销申请
            this.Read(item)

            return
          }

          if (type == 'approval') {
            //用章审核
            this.$router.push({
              path: '/home/seal/SealApprovedetail',
              query: {
                guid: item.infoId
              }
            })
          } else {
            this.$router.push({
              name: 'Sealdetail',
              path: '/home/seal/Sealdetail',
              query: {
                guid: item.infoId
              }
            })
          }
        } else if (item.msgType == 'tender_entry') {
          if (item.tenderStatus == -1) {
            //已撤销申请
            this.Read(item)

            return
          }
          if (type == 'approval') {
            //投标审核
            this.$router.push({
              path: '/home/seal/BidApprovedetail',
              query: {
                guid: item.infoId
              }
            })
          } else {
            this.$router.push({
              name: 'Biddetail',
              path: '/home/seal/Biddetail',
              query: {
                guid: item.infoId
              }
            })
          }
        }
      }
      //未读改成已读
      if (item.status == 1) {
        this.Read(item)
      }
    },
    GetUnRead() {
      NoticeUnread().then((res) => {
        if (res.data.status == 'success') {
          // console.log('res.data.total',res.data);
          if (res.data.total > 0) {
            this.UnReadCount = res.data.total
            this.$store.commit('MessageTotal', res.data.total)
          } else {
            this.UnReadCount = ''
            this.$store.commit('MessageTotal', '')
          }
        }
      })
    },
    readbtn() {
      this.$confirm('是否全部标为已读', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      })
        .then(() => {
          AllRead().then((res) => {
            if (res.data.status == 'success') {
              this.GetUnRead()
              this.notice = this.notice.map((item) => {
                if (item.status === 1) {
                  item.status = 0
                }
                this.isbtn = false
                return item
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    Read(item) {
      //已读
      if (item.status == 1) {
        NoticeRead({ Id: item.id }).then((res) => {
          if (res.data.status == 'success') {
            item.status = 0
            this.GetUnRead()
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          } else {
            this.$message.error(res.data.message)
          }
        })
      }
    }
  },
  created() {
    this.getnotice()
  }
}
</script>
<style>
.el-tooltip__popper {
  max-width: 80%;
}
</style>
<style lang="less" scoped>
#email {
  width: 100%;
}

.tiaoz {
  color: rgba(48, 119, 230, 1);
  width: auto;
  cursor: default;
}

#email .index {
  width: 98%;
  margin: auto;
  border-radius: 16px;
  font-size: 16px;
  min-height: calc(100vh - 120px);
  font: 'PingFang SC';
  position: relative;
}

#email /deep/ .el-card__body,
.el-main {
  padding: 20px 0;
}

#email /deep/.el-tabs__nav {
  padding-left: 45px;
}

#email /deep/ .el-tabs__header {
  margin: 0;
}

#email /deep/.el-tabs__active-bar {
  margin-left: 40px;
}

#email /deep/.el-tabs__item {
  font-size: 16px;
}

#email .main {
  padding: 0 40px;
}

#email .contain {
  width: 100%;
  padding-top: 40px;
}

#email .time {
  font-size: 14px;
  color: #666666;
  margin-bottom: 20px;
}

#email .title {
  color: #111827;
  font-weight: 500px;
  margin-bottom: 24px;
}

#email .xian {
  width: 100%;
  border: 1px solid #e7ebee;
}

#email .item {
  margin-top: 10px;
  margin-right: 40px;
}

// 分页
#email .bank_pagination {
  text-align: right;
  margin-top: 30px;
  padding-left: 20px;
  padding-right: 20px;
}

#email /deep/.el-pagination__total {
  float: left;
}

#email /deep/.el-pagination__sizes {
  float: left;
}

.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

//已读按钮
.readbtn {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 14px;
  cursor: pointer;
  border: none;
}

::v-deep .el-dialog__header {
  text-align: center !important;
}
</style>
  